let cardhobby = {
  addressPage: {
    pageindex: 1,
    pagesize: 999
  },
  sort: [
    'lastontime',
    'price',
    'sales'
  ],
  sortType: [
    'desc',
    'asc'
  ],
  pointOptions: [{
          'value': 'All',
        }, {
          'value': '0-100',
        }, {
          'value': '100-200',
        }, {
          'value': '200-500',
        }],
  dislogType: {
    'market': false,
    'userinfo': false,
    'login': false,
    'register': false,
    'forgot': false,
    'address': false,
    'setOrderAddress': false,
    'payOrder': false,
    'viewexpress': false
  },
  authorize: [
    "../../static/images/footer_mci.svg",
    "../../static/images/footer_fbc.svg",
    "../../static/images/footer_sad.svg",
    "../../static/images/footer_rbf.svg",
    "../../static/images/footer_celtic.svg",
    // "../../static/images/footer_nbpa.svg",
    // "../../static/images/footer_ufc.svg"
  ],
  headerMeu: {
    'home': 'Home',
    'market': 'Market',
    'point': 'Points',
    'cypher': 'Cypher',
    'information': 'Information',
    'about': 'About US'
  },
  otherPayOrder: [
  {
    'method': 'SESOLT21XXX',
    'account': 'LT643710020000011418',
    'company':'Cardhobby Germany GmbH'
  }
  ],
  industry: [{
    value: 'cardstore',
    label: 'Card Store / TCG Shop'
  }, {
    value: 'onlineshop',
    label: 'Online Shop'
  }, {
    value: 'distributor',
    label: 'Distributor / Wholesaler'
  }, {
    value: 'retailstore',
    label: 'Retail Store (Kiosk / Toys / etc.)'
  }, {
    value: 'streamer',
    label: 'Streamer / Breaker'
  }, {
    value: 'other',
    label: 'Other'
  }],
  productRange:[{
    value: 'ptcgen',
    label: 'Pokémon (English)'
  }, {
    value: 'ptcgenzh',
    label: 'Pokémon (Simplified Chinese)'
  }, {
    value: 'sportsCards',
    label: 'Sports Cards'
  }, {
    value: 'op',
    label: 'One Piece / Anime Cards'
  }, {
    value: 'accessories',
    label: 'Accessories (Sleeves, Deck Boxes, etc.)'
  }, {
    value: 'other',
    label: 'Other'
  }],
  productInterest:[{
    value: 'ptcgenzh',
    label: 'Pokémon (Simplified Chinese)'
  }, {
    value: 'lltcg',
    label: 'Riftbound (League of Legends TCG)'
  }, {
    value: 'daka',
    label: 'Sports Cards (DAKA, etc.)'
  }, {
    value: 'Collectibles',
    label: 'Collectibles / Figures'
  }, {
    value: 'accessories',
    label: 'Accessories'
  }],
  volume:[{
    value: '1',
    label: '< €10,000'
  }, {
    value: '2',
    label: '€10,000 – €50,000'
  }, {
    value: '3',
    label: '€50,000 – €100,000'
  }, {
    value: '4',
    label: '€100,000 – €300,000'
  }, {
    value: '5',
    label: '€300,000+'
  }],
  cosConfig: {
    ImagesUrl: "https://images.cardhobby.com/",
    Bucket: "cardhobby-1255531135" /* 必须 */ ,
    Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */ ,
    Key: "exampleobject" /* 必须 */ ,
    Prefix: "", //CardHobby/ /*文件目录*/
    SecretId: "",
    SecretKey: ""
  },
}
export default {
  cardhobby
}



// WEBPACK FOOTER //
// ./src/api/enum.js